import { useState } from 'react';
import { ConfirmationModal, TextField, Typography, useOverlayContext } from 'seagull';
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { handleRequest } from "../../../infra/utils";
import { getPMDetails } from "../../PracticeManagement/pm.utils";
import styles from "./APIKeyModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const APIKeyModal = _ref => {
  let {
    pmName,
    apiKeyListener,
    dismissModal
  } = _ref;
  const [apiKey, setApiKey] = useState('');
  const overlayContext = useOverlayContext();
  const handleChange = e => {
    setApiKey(e.target.value);
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Set API key",
    testId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-modal"),
    textAlignCenter: false,
    width: "640px",
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        children: ["To integrate with ".concat(getPMDetails(pmName).name, ", copy your API key from the Anchor integration page in your ").concat(getPMDetails(pmName).name, " account and paste it into the field below. "), /*#__PURE__*/_jsx(ExternalLinkButton, {
          href: getPMDetails(pmName).articleLink,
          testId: 'learn-more-link',
          openInNewTab: true,
          children: "Learn more"
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.textfield,
        children: /*#__PURE__*/_jsx(TextField, {
          collapseHelperText: false,
          onChange: handleChange,
          testId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-input")
        })
      })]
    }),
    primaryButtonLabel: "Set",
    onPrimaryButtonClick: async () => {
      overlayContext.startLoader('SetAPIKey');
      const {
        success
      } = await handleRequest(apiKeyListener.saveApiKey(apiKey));
      overlayContext.stopLoader('SetAPIKey');
      if (!success) {
        overlayContext.showErrorToast('Failed to set API key. Please check the key and try again.', "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-failed"));
      } else {
        dismissModal();
      }
    },
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => dismissModal(),
    primaryButtonTestId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-submit"),
    secondaryButtonTestId: "".concat(getPMDetails(pmName).testIdPrefix, "-set-api-key-cancel")
  });
};
export default APIKeyModal;